import { render, staticRenderFns } from "./UserProfileUpdatePersonalInfo.vue?vue&type=template&id=452b7a0a"
import script from "./UserProfileUpdatePersonalInfo.vue?vue&type=script&lang=js"
export * from "./UserProfileUpdatePersonalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports